"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
function startCase(s = '') {
    return lodash_1.isString(s)
        ? (s.match(/[\S^()]+/g) || []).map(lodash_1.upperFirst).join(' ')
        : lodash_1.isNil(s)
            ? 'Unknown'
            : lodash_1.toString(s);
}
exports.default = startCase;
